import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API_BASE from "../config/api";
import Swal from "sweetalert2";
import FilterBar from "./FilterBar";
import { Carousel } from "react-bootstrap";


function Listings() {
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const selectedProvince = queryParams.get("location") || "";
    const selectedCategory = queryParams.get("category") || "";

    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);

    const [showCallPopup, setShowCallPopup] = useState(false);
    const [showMsgPopup, setShowMsgPopup] = useState(false);

    const [selectedBiz, setSelectedBiz] = useState(null);
    const [userMsg, setUserMsg] = useState("");
    const [showComplaintPopup, setShowComplaintPopup] = useState(false);
    const [complaintTopic, setComplaintTopic] = useState("");
    const [complaintMsg, setComplaintMsg] = useState("");
    const [filteredListings, setFilteredListings] = useState([]);


    const ITEMS_PER_PAGE = 10;

    const [currentPage, setCurrentPage] = useState(1);


    const makeSlug = (text = "") =>
        text
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\s-]/g, "")
            .replace(/\s+/g, "-");


    const goToProfile1 = (id) => {
        navigate(`/business-website/${id}`);
    };

    // 🔥 Fetch data from backend when page loads
    useEffect(() => {
        setLoading(true); // show loader instantly

        fetch(
            `${API_BASE}/api/searchListings.php?location=${selectedProvince}&category=${selectedCategory}&search=${queryParams.get("search") || ""}`
        )
            .then((res) => res.json())
            .then((data) => {
                const updatedData = (data.data || []).map(item => ({
                    ...item,

                    // 🔥 FIX: normalize flags
                    is_verified: Number(item.is_verified),
                    has_profile: Number(item.has_profile),
                    has_website: Number(item.has_website),

                    rating: (Math.random() * 1 + 4).toFixed(1),
                    reviews: Math.floor(Math.random() * 200) + 1
                }));

                const cleanData = updatedData.map(item => ({
                    ...item,
                    is_verified: Number(item.is_verified) === 1 ? 1 : 0,
                    has_profile: Number(item.has_profile) === 1 ? 1 : 0,
                    has_website: Number(item.has_website) === 1 ? 1 : 0
                }));

                setListings(cleanData);
                setFilteredListings(cleanData);

                setCurrentPage(1);
                setLoading(false);
            })


            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }, [selectedProvince, selectedCategory]);

    {/* SHOW LOADER FIRST */ }
    {
        loading && (
            <div className="text-center my-5">
                <div className="spinner-border text-primary" role="status"></div>
                <p className="text-muted mt-2">Loading results...</p>
            </div>
        )
    }


    const showToast = (message, icon) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: icon,
            title: message,
            showConfirmButton: false,
            timer: 1500,
            customClass: {
                popup:
                    icon === "success"
                        ? "my-toast my-toast-success"
                        : icon === "error"
                            ? "my-toast my-toast-error"
                            : "my-toast my-toast-warning",
            },
        });
    };
    const totalPages = Math.ceil(filteredListings.length / ITEMS_PER_PAGE);

    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;

    const paginatedListings = filteredListings.slice(startIndex, endIndex);
    const listingsScrollRef = useRef(null);
    useEffect(() => {
        if (listingsScrollRef.current) {
            listingsScrollRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }, [currentPage]);
    useEffect(() => {
        const yOffset = -120; // height of sticky header
        const y =
            listingsScrollRef.current.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
    }, [currentPage]);
    const getPageNumbers = () => {
        const maxPagesToShow = 5;

        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + maxPagesToShow - 1);

        if (end - start < maxPagesToShow - 1) {
            start = Math.max(1, end - maxPagesToShow + 1);
        }

        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    return (
        <div className="my-4">

            {/* INTERNAL CSS */}
            <style>{`
                .filter-box {
                    background: #ffffff;
                    

                    padding: 18px;
                    border-radius: 14px;
                    box-shadow: 0 4px 14px rgba(0,0,0,0.10);
                    position: sticky;
                    top: 100px;
                }

                .biz-card {
                    background: #fff;
                    border-radius: 14px;
                    padding: 18px;
                    margin-bottom: 22px;
                    box-shadow: 0 4px 14px rgba(0,0,0,0.12);
                    border: none;
                    transition: 0.25s ease-in-out;
                }

                .biz-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 6px 20px rgba(0,0,0,0.18);
                }

                .biz-img {
                    height: 170px;
                    width: 100%;
                    object-fit: cover;
                    border-radius: 12px;
                }
                    .filter-box-advanced {
    background: #ffffff;
    padding: 22px;
    border-radius: 18px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.08);
    position: sticky;
    top: 100px;
    transition: 0.3s ease-in-out;
}

.filter-box-advanced:hover {
    box-shadow: 0 12px 26px rgba(0,0,0,0.12);
}

/* Tags */
.filter-tag {
    background: #f1f3f5;
    padding: 4px 10px;
    border-radius: 50px;
    font-size: 12px;
    cursor: pointer;
    transition: 0.2s;
}

.filter-tag:hover {
    background: #0d6efd;
    color: white;
}

/* Selects */
.modern-select {
    border: none !important;
    background: #f8f9fa !important;
    padding: 8px !important;
    border-radius: 10px;
    font-size: 14px;
}

/* Rating Badges */
.rating-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.rating-badge {
    background: #f8f9fa;
    padding: 6px 12px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.2s;
    font-size: 14px;
}

.rating-badge:hover {
    background: #ffe08a;
}

/* Buttons */
.reset-btn {
    border-radius: 50px;
    padding: 5px 18px;
    border: 1px solid #ddd;
}

.apply-btn {
    border-radius: 50px;
    padding: 5px 18px;
    font-weight: 600;
}
    .modern-select {
    border-radius: 10px;
    background-color: #f8f9fa !important;
    border: 1px solid #e1e4e8;
    padding: 6px 10px;
    font-size: 13px;
    color: #495057;
    transition: 0.2s ease;
}

.modern-select:hover {
    background-color: #ffffff !important;
    border-color: #c4c9cf;
}

.modern-select:focus {
    border-color: #0d6efd !important;
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.15);
}.filter-box-advanced {
    background: #ffffff;
    padding: 22px;
    border-radius: 18px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.08);
    position: sticky;
    top: 100px;

    /* 🔥 Make Scrollable */
    max-height: 82vh;
    overflow-y: auto;
    padding-right: 8px;
}

/* Slim Modern Scrollbar */
.filter-box-advanced::-webkit-scrollbar {
    width: 6px;
}

.filter-box-advanced::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 10px;
}

.filter-box-advanced::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}
.website-text {
  color: #ffffff !important;   /* white text */
}

.website-text:hover {
  color: #ffffff !important;   /* keep white on hover */
}
/* CORPORATE PAGINATION */
.corp-pagination {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  padding: 10px 14px;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(0,0,0,0.12);
}

.corp-page-btn {
  border: 1px solid #dcdfe6;
  background: #ffffff;
  color: #3559E0;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  min-width: 42px;
}

.corp-page-btn:hover:not(:disabled) {
  background: #eef2ff;
  border-color: #3559E0;
  transform: translateY(-1px);
}

.corp-page-btn.active {
  background: #3559E0;
  color: #ffffff;
  border-color: #3559E0;
  box-shadow: 0 4px 12px rgba(53, 89, 224, 0.4);
}

.corp-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}




            `}</style>

            <FilterBar listings={listings} onFilter={(data) => {
                setFilteredListings(data);
                setCurrentPage(1);
            }} />



            <br></br>
            <div ref={listingsScrollRef}></div>
            <div className="row g-4">

                <div className="col-md-3 mb-4">
                    <div
                        className="position-sticky"
                        style={{ top: "160px", zIndex: 1 }}

                    >

                        <div className="card shadow-sm mb-4" style={{
                            borderRadius: "10px",
                            overflow: "hidden",

                            minHeight: "400px"     // or any height you like, e.g. 300 / 350 / 400
                        }}>
                            <Carousel interval={2000} controls indicators>
                                <Carousel.Item>
                                    <img
                                        src="/assets/L1.png"
                                        className="d-block w-100"
                                        alt="Ad 1"
                                        style={{ borderRadius: "10px" }}
                                    />
                                </Carousel.Item>

                                <Carousel.Item>
                                    <img
                                        src="/assets/L2.png"
                                        className="d-block w-100"
                                        alt="Ad 2"
                                        style={{ borderRadius: "10px" }}
                                    />
                                </Carousel.Item>

                                <Carousel.Item>
                                    <img
                                        src="/assets/L3.png"
                                        className="d-block w-100"
                                        alt="Ad 3"
                                        style={{ borderRadius: "10px" }}
                                    />
                                </Carousel.Item>
                            </Carousel>
                        </div>

                    </div>

                </div>



                {/* RIGHT LISTINGS */}
                <div className="col-md-9">
                    <div className="position-sticky"
                        style={{ top: "160px", zIndex: 1 }} >
                        {/* BIG LOADER */}
                        {loading && (
                            <div className="text-center my-5">
                                <div
                                    className="spinner-border text-primary"
                                    style={{ width: "4rem", height: "4rem" }}
                                    role="status"
                                ></div>
                                <p className="text-muted mt-3 fs-5">Loading results...</p>
                            </div>
                        )}

                        {/* NO RESULT */}
                        {!loading && filteredListings.length === 0
                            && (
                                <p className="text-muted fs-5">No results found.</p>
                            )}

                        {/* RESULTS */}
                        {!loading &&

                            filteredListings.length > 0 &&
                            paginatedListings.map((biz, index) => (


                                <div key={biz.id} className="card mb-3 border border-secondary shadow-sm rounded-1">


                                    <div className="row g-0">

                                        {/* IMAGE (Full width in mobile, left side in desktop) */}
                                        <div className="col-12 col-md-4">
                                            <img
                                                src={biz.profilepics && biz.profilepics.trim() !== ""
                                                    ? biz.profilepics
                                                    : "/assets/defaultList.jpg"}
                                                className="img-fluid rounded-start w-100"
                                                style={{ height: "100%", maxHeight: "260px", objectFit: "cover" }}
                                                alt={biz.title}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = "/assets/defaultList.jpg";
                                                }}
                                            />
                                        </div>


                                        {/* MIDDLE CONTENT */}
                                        <div className="col-12 col-md-6 p-3">

                                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                                <h5 className="fw-bold mb-0">{biz.title}</h5>
                                                {biz.is_verified === 1 ? (
                                                    <span className="badge bg-success">
                                                        <i className="bi bi-patch-check-fill me-1"></i> Verified
                                                    </span>
                                                ) : (
                                                    <span
                                                        className="badge d-inline-flex align-items-center"
                                                        style={{
                                                            background: "rgba(13, 110, 253, 0.08)",
                                                            color: "#0d6efd",
                                                            border: "1px solid rgba(13, 110, 253, 0.25)",
                                                            borderRadius: "999px",
                                                            padding: "6px 12px",
                                                            fontSize: "12px",
                                                            fontWeight: 600,
                                                            backdropFilter: "blur(4px)"
                                                        }}
                                                    >
                                                        <i className="bi bi-lightning-fill me-1"></i>
                                                        Free
                                                    </span>


                                                )}

                                            </div>

                                            <p className="text-muted small mb-1">
                                                <i className="bi bi-geo-alt-fill text-primary"></i>{" "}
                                                {biz.muncipality}, {biz.district}, {biz.province}
                                            </p>

                                            <div className="d-flex flex-wrap gap-1 mb-2">
                                                {biz.keywords &&
                                                    biz.keywords
                                                        .split(",")
                                                        .map(k => k.trim())
                                                        .filter(k => k.length > 0)
                                                        .slice(0, 4)
                                                        .map((tag, i) => (
                                                            <span key={i} className="badge bg-light text-dark">
                                                                {tag}
                                                            </span>
                                                        ))}
                                            </div>

                                            <p className="small text-muted mb-2">
                                                {biz.descriptions?.substring(0, 100)}...
                                            </p>

                                            {/* CONTACT INFO */}
                                            <div className="small">
                                                <div className="mb-1 d-flex align-items-center gap-2">
                                                    <i className="bi bi-telephone-fill text-success"></i>

                                                    {/* Mask / Unmask logic */}
                                                    <strong>
                                                        {biz.showNumber
                                                            ? biz.mobile
                                                            : biz.mobile.slice(0, 2) + "XXXXXX" + biz.mobile.slice(-2)}
                                                    </strong>

                                                    {/* Icon toggle instead of button */}
                                                    <i
                                                        className={`bi ms-2 ${biz.showNumber ? "bi-eye-slash" : "bi-eye"}`}
                                                        style={{ cursor: "pointer", color: "#0d6efd" }}
                                                        onClick={() => {
                                                            setListings((prev) =>
                                                                prev.map((item) =>
                                                                    item.id === biz.id ? { ...item, showNumber: !item.showNumber } : item
                                                                )
                                                            );
                                                        }}
                                                    ></i>
                                                </div>





                                                <div className="mb-1">
                                                    <i className="bi bi-envelope-fill text-danger me-2"></i>
                                                    {biz.email}
                                                </div>
                                                <div>
                                                    <i className="bi bi-globe text-primary me-2"></i>
                                                    {biz.website}
                                                </div>
                                            </div>

                                            {/* BUTTONS */}
                                            <div
                                                className="d-flex align-items-center flex-wrap mt-3"
                                                style={{ gap: "4px" }}
                                            >
                                                <button
                                                    className="btn btn-success btn-sm d-flex align-items-center m-0"
                                                    onClick={() => {
                                                        setSelectedBiz(biz);
                                                        setShowCallPopup(true);
                                                    }}
                                                >
                                                    <span style={{ color: "#ffffff" }}><i className="bi bi-telephone-fill"></i> Call</span>

                                                </button>

                                                {biz.has_website === 1 && (
                                                    <button
                                                        className="btn btn-primary btn-sm d-flex align-items-center m-0"
                                                        onClick={() => goToProfile1(biz.id)}
                                                    >
                                                        <span className="website-text">
                                                            <i className="bi bi-globe"></i> Website
                                                        </span>
                                                    </button>
                                                )}


                                                <button
                                                    className="btn btn-warning btn-sm text-dark d-flex align-items-center m-0"
                                                    onClick={() => {
                                                        setSelectedBiz(biz);
                                                        setUserMsg("");
                                                        setShowMsgPopup(true);
                                                    }}
                                                >

                                                    <i className="bi bi-chat-dots-fill"></i> Message
                                                </button>

                                                {biz.has_profile === 1 && (
                                                    <button
                                                        className="btn btn-outline-secondary btn-sm d-flex align-items-center m-0"
                                                        onClick={() => navigate(`/portfolio/${makeSlug(biz.title)}`)}

                                                    >
                                                        <i className="bi bi-eye-fill"></i> Profile
                                                    </button>
                                                )}

                                            </div>


                                        </div>

                                        {/* RIGHT SIDE RATING */}
                                        {/* RIGHT SIDE RATING + COMPLAINT */}
                                        <div className="col-12 col-md-2 p-3 text-md-end text-start d-flex flex-column justify-content-between">

                                            {/* Rating */}
                                            <div>
                                                <span className="badge bg-warning text-dark px-3 py-2 fs-6">
                                                    ⭐ {biz.rating}
                                                </span>
                                                <p className="small text-muted mt-1 mb-0">{biz.reviews} Reviews</p>
                                            </div>

                                            {/* Complaint Button on SAME ROW visually */}
                                            {/* Complaint Icon */}
                                            <i
                                                className="bi bi-exclamation-octagon-fill text-danger fs-5"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    setSelectedBiz(biz);
                                                    setComplaintTopic("");
                                                    setComplaintMsg("");
                                                    setShowComplaintPopup(true);
                                                }}
                                                title="Report / Complaint"
                                            />

                                            {/* COMPLAINT POPUP */}
                                            {showComplaintPopup && selectedBiz && (
                                                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                                    style={{ background: "rgba(0,0,0,0.5)", zIndex: 2000 }}>

                                                    <div className="bg-white p-4 rounded shadow" style={{ width: "360px" }}>

                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <h5 className="mb-0">Report Issue</h5>
                                                            <button className="btn btn-sm btn-danger" onClick={() => setShowComplaintPopup(false)}>X</button>
                                                        </div>

                                                        {/* TOPIC */}
                                                        <label className="fw-semibold small">Complaint Type</label>
                                                        <select
                                                            className="form-select mb-3"
                                                            value={complaintTopic}
                                                            onChange={(e) => setComplaintTopic(e.target.value)}
                                                        >
                                                            <option value="">Select Topic</option>
                                                            <option>Fake Business</option>
                                                            <option>Wrong Information</option>
                                                            <option>Fraud / Scam</option>
                                                            <option>Duplicate Listing</option>
                                                            <option>Other</option>
                                                        </select>

                                                        {/* MESSAGE */}
                                                        <label className="fw-semibold small">Your Message</label>
                                                        <textarea
                                                            className="form-control mb-3"
                                                            rows="3"
                                                            placeholder="Write your complaint..."
                                                            value={complaintMsg}
                                                            onChange={(e) => setComplaintMsg(e.target.value)}
                                                        ></textarea>

                                                        <button
                                                            className="btn btn-dark w-100"
                                                            onClick={async () => {
                                                                if (!complaintTopic || !complaintMsg) {
                                                                    showToast("Please fill all fields", "error");
                                                                    return;
                                                                }

                                                                // Ensure selectedBiz has the uid field (adjust name if needed)
                                                                const listingUid = selectedBiz.listinguid ?? selectedBiz.listing_uid ?? selectedBiz.id ?? "";

                                                                if (!listingUid) {
                                                                    showToast("Listing UID missing on selected business!", "error");
                                                                    console.error("selectedBiz missing uid:", selectedBiz);
                                                                    return;
                                                                }

                                                                const payload = {
                                                                    listing_uid: listingUid,   // server accepts this (also supports listinguid or biz_id)
                                                                    topic: complaintTopic,
                                                                    message: complaintMsg
                                                                };

                                                                console.log("Submitting complaint payload:", payload); // <-- debug

                                                                try {
                                                                    const res = await fetch(`${API_BASE}/api/saveComplaint.php`, {
                                                                        method: "POST",
                                                                        headers: { "Content-Type": "application/json" },
                                                                        body: JSON.stringify(payload)
                                                                    });

                                                                    const data = await res.json();
                                                                    console.log("API response:", data);

                                                                    if (data.success) {
                                                                        showToast(data.message || "Complaint submitted successfully!", "success");
                                                                        setShowComplaintPopup(false);
                                                                    } else {
                                                                        showToast(data.message || "Something went wrong", "error");
                                                                    }
                                                                } catch (err) {
                                                                    console.error("Network or server error:", err);
                                                                    showToast("Server error", "error");
                                                                }
                                                            }}

                                                        >
                                                            Submit Complaint
                                                        </button>

                                                    </div>
                                                </div>
                                            )}


                                        </div>

                                    </div>
                                </div>
                            ))}
                    </div>
                </div>



                {/* CALL POPUP */}
                {showCallPopup && selectedBiz && (
                    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        style={{ background: "rgba(0,0,0,0.5)", zIndex: 9999 }}>

                        <div className="bg-white p-4 rounded shadow" style={{ width: "320px" }}>

                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">{selectedBiz.title}</h5>
                                <button className="btn btn-sm btn-danger" onClick={() => setShowCallPopup(false)}>X</button>
                            </div>

                            {/* PHONE NUMBER */}
                            <div className="text-center mb-3">
                                <h4 className="fw-bold">{selectedBiz.mobile}</h4>
                            </div>

                            <button
                                className="btn btn-success w-100 mb-2"
                                onClick={() => window.location.href = `tel:${selectedBiz.mobile}`}
                            >
                                <i className="bi bi-telephone-fill"></i> Call Now
                            </button>

                            <button
                                className="btn btn-outline-success w-100 mb-2"
                                onClick={() => {
                                    setShowCallPopup(false);
                                    setUserMsg("");
                                    setShowMsgPopup(true);
                                }}
                            >
                                <i className="bi bi-whatsapp"></i> WhatsApp Message
                            </button>

                            <button
                                className="btn btn-secondary w-100"
                                onClick={() => {
                                    navigator.clipboard.writeText(selectedBiz.mobile);
                                    alert("Phone number copied!");
                                }}
                            >
                                <i className="bi bi-clipboard-check"></i> Copy Number
                            </button>
                        </div>
                    </div>
                )}
                {/* MESSAGE POPUP */}
                {showMsgPopup && selectedBiz && (
                    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        style={{ background: "rgba(0,0,0,0.5)", zIndex: 9999 }}>

                        <div className="bg-white p-4 rounded shadow" style={{ width: "350px" }}>

                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">Message {selectedBiz.title}</h5>
                                <button className="btn btn-sm btn-danger" onClick={() => setShowMsgPopup(false)}>X</button>
                            </div>

                            <p className="fw-bold small">Choose a message:</p>

                            {[
                                "Hello! I want to know more about your services.",
                                "Please share pricing details.",
                                "I am interested, please contact me.",
                                "Is this service available right now?"
                            ].map((msg, idx) => (
                                <button
                                    key={idx}
                                    onClick={() => setUserMsg(msg)}
                                    className="btn btn-outline-secondary text-start mb-2"
                                >
                                    {msg}
                                </button>
                            ))}

                            <textarea
                                className="form-control mt-3"
                                rows="3"
                                placeholder="Type your message..."
                                value={userMsg}
                                onChange={(e) => setUserMsg(e.target.value)}
                            ></textarea>

                            <button
                                className="btn btn-success w-100 mt-3"
                                onClick={() => {
                                    const phone = selectedBiz.mobile;
                                    const text = encodeURIComponent(userMsg);
                                    window.open(`https://wa.me/${phone}?text=${text}`, "_blank");
                                }}
                            >
                                <i className="bi bi-whatsapp"></i> Send on WhatsApp
                            </button>
                        </div>
                    </div>
                )}



            </div>
            {/* CORPORATE PAGINATION – BOTTOM RIGHT */}
            {totalPages > 1 && (
                <div className="d-flex justify-content-end mt-4">
                    <div className="corp-pagination">

                        {/* PREV */}
                        <button
                            className="corp-page-btn"
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                        >
                            ‹ Prev
                        </button>

                        {/* PAGE NUMBERS */}
                        {getPageNumbers().map(p => (
                            <button
                                key={p}
                                className={`corp-page-btn ${currentPage === p ? "active" : ""}`}
                                onClick={() => setCurrentPage(p)}
                            >
                                {p}
                            </button>
                        ))}

                        {/* NEXT */}
                        <button
                            className="corp-page-btn"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                        >
                            Next ›
                        </button>

                    </div>
                </div>
            )}


        </div>
    );

}

export default Listings;
